import V2Layout from '../layout/V2Layout.vue'

export default [
  {
    path: '/v2',
    component: V2Layout,
    children: [
      { path: '', redirect: 'dashboard' },
      {
        path: 'dashboard',
        component: () => import('../pages/Dashboard.vue'),
        children: [
          { path: '', name: 'V2Dashboard', redirect: 'simple' },
          { path: 'simple', name: 'V2DashboardSimple', component: () => import('../pages/dashboard/SimpleView.vue') },
          { path: 'detailed', name: 'V2DashboardDetailed', component: () => import('../pages/dashboard/DetailedView.vue') },
          { path: 'payouts', name: 'V2DashboardPayouts', component: () => import('../pages/dashboard/Payouts.vue') },
          { path: 'deals', name: 'V2DashboardDeals', component: () => import('../pages/dashboard/SyndicatedDeals.vue') },
        ],
      },
      { path: 'fcs/:unique_id', name: 'V2Fcs', component: () => import('../pages/Fcs.vue') },
      { path: 'accounting_reply/:unique_id', name: 'V2AccountingReply', component: () => import('../pages/AccountingReply.vue') },
      { path: 'iso-potal/:unique_id/:user_id/:lender_id', name: 'V2AcceptOffer', component: () => import('../pages/AcceptOfferForm.vue') },
      { path: 'profile', name: 'V2Profile', component: () => import('../pages/Profile.vue') },
      { path: 'super-syndicate', name: 'V2SuperSyndicate', component: () => import('../pages/SuperSyndicate.vue') },
    ],
  },
  { path: '/v2/plaid', name: 'V2Plaid', component: () => import('../pages/Plaid.vue') },
]
